<div class="card app-tile new-card">
  <div class="card-body app-tile-body p-0">
    <mat-card-title>
      <div class="icon-frame new-icon-frame-size">
        <img
          src="{{ card.AppImageURL }}"
          alt="application-logo"
          class="app-icon card-img"
        />
      </div>
      <div>
        <mat-card-title-text>
          <div class="row">
            <div class="col-12 p-0">
              <p
                class="card-text app-name-no-hover card-title"
                style="width: 100%"
                tt_datatestid="card-name-tooltip"
                tt_datapendoid="card-name-tooltip"
                tt_arialabel="Card name tooltip"
                [rw-tooltip]="card?.AppName"
                placement="top"
              >
                {{ card?.AppName }}
              </p>
            </div>
          </div>
        </mat-card-title-text>
      </div>
    </mat-card-title>
    <mat-card-actions>
      <div class="button-container">
        <app-button
          id="btnDownload"
          label="DOWNLOAD"
          buttonStyle="changeSeatCount"
          (clickActionEmitter)="install()"
          noContentPadding="true"
        >
        </app-button>
      </div>
    </mat-card-actions>
  </div>
</div>
